import axios from 'axios';
import {
  setToken,
  getParsedToken,
  setRefreshToken,
  getRefreshToken,
} from '@/assets/js/utils/auth';
import { getDomain } from '@/assets/js/utils/browser';

const locale = getDomain() ? getDomain()[0] : '';
const LOGIN = `${process.env['API-GATEWAY']}/auth/login`;
const REFRESH = token => `${process.env['API-GATEWAY']}/auth/refresh?refresh_token=${token}`;
export const LOGOUT = `${process.env.API_FRONT}${locale}/cabinet_logout`;

export function updateCredentials(data, remember) {
  const { access_token: accessToken, refresh_token: refreshToken } = data;
  setToken(accessToken, remember);
  if (remember) {
    setRefreshToken(refreshToken);
  }
}

const AuthService = {
  login: (credentials, remember = true) => {
    const data = {
      ...credentials,
      companyId: process.env.COMPANY_ID,
    };

    return axios.post(
      LOGIN,
      {
        name: 'form_based',
        data,
      },
    )
      .then((response) => {
        updateCredentials(response.data, remember);
        return response.data.access_token;
      });
  },
  refresh: () => {
    const refreshToken = getRefreshToken();
    if (!refreshToken) return Promise.reject();
    return axios.post(REFRESH(refreshToken))
      .then(({ data }) => updateCredentials(data, true));
  },
  getProfile: () => {
    const data = getParsedToken();
    return data.profile ? data.profile : null;
  },
};

export default AuthService;



// WEBPACK FOOTER //
// ./src/services/AuthService.js